import { MutationCache, QueryClient } from '@tanstack/react-query'

import { errorTypeService } from './services/errorTypeService'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Don't retry the query if we got a 404 error
        if (errorTypeService.is404Error(error)) {
          return false
        }

        // Otherwise, retry upto 3 times (same as the default behaviour)
        return failureCount <= 2
      },
    },
  },
  mutationCache: new MutationCache({
    onSuccess: () => {
      queryClient.invalidateQueries()
    },
  }),
})
